/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserGachaDatesResponse } from '../../models/get-user-gacha-dates-response';

export interface UserServiceGetUserGachaDates2$Params {
  userUuid: string;
  discordId?: string;

/**
 * Optional. If set, only select the given.
 */
  gachaIds?: Array<string>;
}

export function userServiceGetUserGachaDates2(http: HttpClient, rootUrl: string, params: UserServiceGetUserGachaDates2$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserGachaDatesResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUserGachaDates2.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
    rb.query('gachaIds', params.gachaIds, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserGachaDatesResponse>;
    })
  );
}

userServiceGetUserGachaDates2.PATH = '/api/v3/gateway/user/{userUuid}/gacha/dates';
